import { render } from "./Page-Contact.vue?vue&type=template&id=45ca4783&scoped=true"
import script from "./Page-Contact.vue?vue&type=script&lang=js"
export * from "./Page-Contact.vue?vue&type=script&lang=js"

import "./Page-Contact.vue?vue&type=style&index=0&id=45ca4783&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45ca4783"

export default script